export default "__VITE_ASSET__C_zRtIWl__"